import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/common/Collapsible';
import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface SettingSectionProps {
    title: string,
    isExpand?: boolean,
    content: React.ReactNode,
    className?: string
}

const SettingSection: React.FC<SettingSectionProps> = ({ title, isExpand = true, content, className }) => {
    const [open, setOpen] = useState<boolean>(isExpand);
    return (
        <Collapsible className={`${className ?? ''}`} open={open} onOpenChange={setOpen}>
            <CollapsibleTrigger className='w-full'>
                <div className={`flex justify-between content-center px-6 py-2.5 bg-primaryWeb ${open ? 'rounded-t-xl' : 'rounded-xl'}`}>
                    <div className='text-background-3 font-medium text-fs-mid16'>{title}</div>
                    <div className='text-background-3 content-center'>
                        {open ? <ChevronDown className='w-5 h-5' /> : <ChevronUp className='w-5 h-5' />}
                    </div>
                </div>
            </CollapsibleTrigger>
            <CollapsibleContent className={`w-full bg-background-3 p-6 ${open ? 'rounded-b-xl' : 'rounded-xl'}`}>
                {content}
            </CollapsibleContent>
        </Collapsible>
    );
};

export default SettingSection;
